import { useContext } from "react";

import { IToastsContext, ToastsContext } from "./ToastsContext";

export function useToasts(): IToastsContext {
  const context = useContext(ToastsContext);
  if (!context) {
    throw new Error("useToasts must be used within a ToastsProvider");
  }

  return context;
}
